import { Component, OnInit, OnDestroy, ElementRef, ViewChild, HostListener } from '@angular/core';
import { EDeliveryService } from '../../services/edelivery.service';
import { Optional, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GridOptions, Module } from '@ag-grid-community/all-modules';
import { PershingGridHeaderComponent } from '@pershing/pershing-grid2';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { EdeliveryLabels } from '../../i18n/edelivery-labels';
import { PershingTranslationService } from '@pershing/pershing-core';
import { Account } from '../../models/account.model';
import { AccountsResult } from '../../models/accounts-result.model';

@Component({
    selector: 'confirmation',
    templateUrl: './confirmation.component.html',
    styleUrls: ['./confirmation.component.css']
})
export class ConfirmationComponent implements OnInit, OnDestroy {

    confirmationData: any;
    gridOptions: GridOptions;
    public modules: Module[] = [ClientSideRowModelModule];

    // Labels
    confirmationPopupTitle = EdeliveryLabels.CONFIRMATION_POPUP_TITLE;
    confirmationPopupText = EdeliveryLabels.CONFIRMATION_POPUP_TEXT;
    enrolledLabel = EdeliveryLabels.ENROLLED;
    deEnrolledLabel = EdeliveryLabels.DE_ENROLLED;
    okButtonLabel = EdeliveryLabels.OK;
    cancelLabel = EdeliveryLabels.CANCEL;
    maskAccountNumber: boolean = false;

    @ViewChild('focusInput') focusInput: ElementRef;

    constructor(public eDeliveryService: EDeliveryService, @Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<ConfirmationComponent>,
            @Optional() @Inject('AppSettings') appSettings: any, private translate: PershingTranslationService) {
        if (this.translate) {
            this.translate.addTranslationFolder('@pershing/edc-newedelivery', 'node_modules/@pershing/edc-newedelivery/lib');
        }
        if (appSettings != null && appSettings.entitlementJson) {
            for ( let i = 0; i < appSettings.entitlementJson.length; i++ ) {
                if (appSettings.entitlementJson[i] === 'MASK_ACCOUNT_NUMBERS') {
                    this.maskAccountNumber = true;
                }
            }
        }
        this.confirmationData = data;
        if (window.innerWidth < 510) {

        }
        this.gridOptions = <GridOptions>{
            rowHeight: (window.innerWidth < 510) ? 38 : 30,
            headerHeight: 30,
            enableColResize: true,
            // suppressMovableColumns: true,
            // suppressCellSelection: true,
            // suppressFocusAfterRefresh: true,
            // suppressTabbing: true,
            domLayout: 'autoHeight',
            // tabIndex: -1,
            defaultColDef: {
                headerComponentFramework: PershingGridHeaderComponent
                // suppressKeyboardEvent: suppressNavigation,
                // suppressHeaderKeyboardEvent: suppressNavigation,
            },
            columnDefs: this.createColumnDefs(),
            onGridSizeChanged: () => {
                if (this.gridOptions.api) { this.gridOptions.api.sizeColumnsToFit(); }
            },
            onGridReady: ($event) => {
                if (!this.gridOptions.api) {
                    this.gridOptions.api = $event.api;
                }
                if (!this.gridOptions.columnApi) {
                    this.gridOptions.columnApi = $event.columnApi;
                }
                if (this.confirmationData.accounts !== undefined) {
                    this.gridOptions.api.setRowData(this.formatRowData(this.confirmationData));
                }
                this.gridOptions.api.hideOverlay(); // Ensure any overlays are cleared
                this.gridOptions.api.sizeColumnsToFit(); // Ensure columns are sized to fit the screen
            }
        };        
    }
    ngOnInit() {
    }

    ngOnDestroy() {
        this.dialogRef.close();
    }

    @HostListener('focusout', ['$event']) public onListenerTriggered(event: any): void {
        this.setFocusToInput();    
    }

    setFocusToInput() {
        this.focusInput.nativeElement.focus();
    }

    createColumnDefs(): any[] {
        return [
            { headerName: EdeliveryLabels.ACCOUNT, width: 290, maxWidth: 290, minWidth: 290, field: 'accountNumber', headerClass: 'left-align', cellClass: 'left-align' },
            { headerName: EdeliveryLabels.EDELIVERY_DOCUMENTS, minWidth: 200, maxWidth: 350, field: 'eDeliveryDocuments', headerClass: 'left-align' },
            { headerName: '', minWidth: 150, maxWidth: 150, field: 'status', cellClass: 'left-align' }
        ];
    }

    // For Grid Accounts View
    formatRowData(confirmationData: AccountsResult): any[] {
        let rows: any[] = [];
        console.log('accounts count: ', confirmationData.accounts.length);
        for (let i = 0; i < confirmationData.accounts.length; i++) {
            let account: Account = confirmationData.accounts[i];
            if (!account.edelElgible) {
                continue;
            }
            for (let j = 0; j < account.edeliveryDocuments.length; j++) {
                if (!account.edeliveryDocuments[j].docEligible) {
                    continue;
                }
                let currentStatus = '';
                if (account.edeliveryDocuments[j].preferenceType.deliveryPreference === 1) {
                    // currentStatus = this.deEnrolledLabel;
                    currentStatus = this.translate.translate.instant(this.deEnrolledLabel);
                } else if (account.edeliveryDocuments[j].preferenceType.deliveryPreference === 2) {
                    // currentStatus = this.enrolledLabel;
                    currentStatus = this.translate.translate.instant(this.enrolledLabel);
                }
                let displayAccountValue: string = '';
                if (this.maskAccountNumber === true) {
                    if (account.shortName != null && account.shortName.length > 0) {
                        displayAccountValue = account.shortName + ' x' + account.accountNumber.slice(account.accountNumber.length - 4);
                    } else {
                        displayAccountValue = 'xxxxx' + account.accountNumber.slice(account.accountNumber.length - 4);
                    }
                } else {
                    if (account.shortName != null && account.shortName.length > 0) {
                        displayAccountValue = account.shortName + ' ' + account.accountNumber;
                    } else {
                        displayAccountValue = account.accountNumber;
                    }
                }
                rows.push({
                    accountNumber: displayAccountValue,
                    eDeliveryDocuments: this.findNameAccordingToLabel(account.edeliveryDocuments[j].edocumentType.docTypeDesc),
                    status: currentStatus
                });
            }
        }
        return rows;
    }

    findNameAccordingToLabel(name) {
        let documentLabel;
        if (name === 'Statements and Reports') {
            documentLabel = EdeliveryLabels.STATEMENTS;
        } else if (name === 'Trade Confirmations') {
            documentLabel = EdeliveryLabels.TRADE;
        } else if (name === 'Notifications') {
            documentLabel = EdeliveryLabels.NOTIFICATIONS;
        } else if (name === 'Tax Documents') {
            documentLabel = EdeliveryLabels.TAX;
        } else if (name === 'Quarterly Performance Reports') {
            documentLabel = EdeliveryLabels.QPR;
        } else if (name === 'Prospectus') {
            documentLabel = EdeliveryLabels.PROSPECTUS;
        } else if (name === 'Proxy/Shareholder Communications') {
            documentLabel = EdeliveryLabels.PROXY;
        }
        return this.translate.translate.instant(documentLabel);
    }

    close() {
        this.dialogRef.close();
    }

}
